import utils from 'utils'

class fullEleInvoiceChooseUkeyModal {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, $filter, $uibModalInstance, $stateParams, items1) {
        $scope.title = items1.title
        $scope.tips = items1.tips
        $scope.ukeyList = $scope.userInfo.tax4UkeyList
        $scope.ukeyId = $scope.ukeyList[0].ukeyId
        // 关闭
        $scope.chooseUkey = function (item) {
            $scope.ukeyId = item.ukeyId
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.ok = function () {
            if (!$scope.ukeyId) return logger.logError('请选择开票点')
            $uibModalInstance.close($scope.ukeyId)
        }
    }
}

fullEleInvoiceChooseUkeyModal.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', '$filter', '$uibModalInstance', '$stateParams', 'items1']
export default fullEleInvoiceChooseUkeyModal



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoice/fullEleInvoiceChooseUkeyModal.js